export default __webpack_public_path__ + "static/logo-7918d2b76def7157292282367cb3f66d.svg";